// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__-5Vvc","legacyBtn":"MutateMid_legacyBtn__oLnKm"};